import { useAppSelector } from "@/app/appStore";

export function PolygonVisibilityWrapper({
  children,
}: React.PropsWithChildren) {
  const isPolygonsVisible = useAppSelector(
    (state) => state.planogram.isPolygonsVisible
  );

  if (!isPolygonsVisible) {
    return null;
  }

  return children;
}
